
    var riot = require('riot')
    
riot.tag2('top-mv-image', '<div class="image" data-src="{data.img}"><a if="{setHref(data.href)}" href="{data.href}" data-gatitle="{data.ga}" target="{data.target}"></a><span if="{!setHref(data.href)}"></span></div>', '', '', function(opts) {
    const self = this
    self.data = opts.data
    self.update()

    this.setHref = function(href) {
      switch (href) {
        case '':
        case false:
        case null:
          return false
        default:
          return href
      }
    }.bind(this)

    self.on('mount', ()=> {
      $(".image", self.root).Lazy({
        effect: 'fadeIn',
        effectTime: 400
      })
    })
});
    
  


// WEBPACK FOOTER //
// ./_src/js/riot/top-mv-image.tag